import React from 'react';
import { CheckCircle, Clock } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Benefits() {
  return <section className="py-16 px-4 bg-white" data-id="element-16">
      <div className="max-w-4xl mx-auto text-center" data-id="element-17">
        <h2 className="text-3xl md:text-5xl font-black text-slate-900 mb-8 leading-tight" data-id="element-18">
          Un sistema pensado para resolver el{' '}
          <span className="highlight-yellow" data-id="element-19">trabajo real del docente.</span>
        </h2>

        <p className="text-xl md:text-2xl text-slate-700 mb-16 font-medium max-w-3xl mx-auto" data-id="element-20">
          El Manual Académico de Biología fue diseñado para que no tengas que
          pasar horas creando material desde cero. Todo ya está organizado para
          ayudarte a enseñar mejor y ahorrar tiempo todas las semanas.
        </p>

        <div className="bg-brand-600 text-white rounded-3xl p-8 md:p-12 shadow-xl mb-16" data-id="element-21">
          <h3 className="text-2xl md:text-4xl font-black mb-10 text-white" data-id="element-22">
            Entrás al aula con la tranquilidad de saber que ya tenés:
          </h3>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-left max-w-3xl mx-auto mb-12" data-id="element-23">
            {['qué enseñar', 'cómo explicarlo', 'qué mostrar', 'qué actividad realizar', 'cómo evaluar'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-brand-700/50 p-4 rounded-xl border border-brand-400/30" data-id="element-24">
                <CheckCircle className="text-brand-200 shrink-0" size={24} data-id="element-25" />
                <span className="font-bold text-lg" data-id="element-26">{item}</span>
              </div>)}
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-2xl md:text-4xl font-black uppercase tracking-tight" data-id="element-27">
            <div className="flex items-center gap-3" data-id="element-28">
              <Clock size={36} data-id="element-29" />
              <span data-id="element-30">Menos horas preparando.</span>
            </div>
            <div className="hidden md:block opacity-40" data-id="element-31">|</div>
            <div className="flex items-center gap-3 text-brand-200" data-id="element-32">
              <CheckCircle size={36} data-id="element-33" />
              <span data-id="element-34">Más tiempo enseñando.</span>
            </div>
          </div>
        </div>

        <div className="text-left max-w-2xl mx-auto mb-16" data-id="element-35">
          <h3 className="text-3xl font-black text-slate-900 mb-8 text-center" data-id="element-36">
            Imaginate entrar a clase con{' '}
            <span className="text-brand-600" data-id="element-37">TODO preparado.</span>
          </h3>

          <ul className="space-y-4 text-xl font-medium text-slate-700 mb-10" data-id="element-38">
            <li className="flex items-center gap-3" data-id="element-39">
              <span className="text-red-500 font-bold text-2xl" data-id="element-40">✕</span> Sin
              quedarte hasta tarde armando material.
            </li>
            <li className="flex items-center gap-3" data-id="element-41">
              <span className="text-red-500 font-bold text-2xl" data-id="element-42">✕</span> Sin
              buscar actividades a último momento.
            </li>
            <li className="flex items-center gap-3" data-id="element-43">
              <span className="text-red-500 font-bold text-2xl" data-id="element-44">✕</span> Sin
              improvisar contenidos.
            </li>
          </ul>

          <div className="bg-brand-50 p-8 rounded-2xl border-2 border-brand-200 text-center" data-id="element-45">
            <p className="text-2xl font-bold text-slate-800 mb-6" data-id="element-46">
              Simplemente:
            </p>
            <div className="flex flex-col gap-4 text-xl font-black text-brand-800" data-id="element-47">
              <p data-id="element-48">1️⃣ abrís el sistema</p>
              <p data-id="element-49">2️⃣ elegís el tema</p>
              <p className="text-2xl text-brand-600" data-id="element-50">
                3️⃣ y ya tenés la clase organizada.
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-center" data-id="element-51">
          <CTAButton data-id="element-52" />
        </div>
      </div>
    </section>;
}